import React from 'react';
import { Redirect } from 'react-router-dom';

import { FolderTypeValues } from 'modules/shared/models';
import { concatUrl } from 'modules/shared/utils';

import { routes } from '../../../../config';
import { RedirectToPersonalSpaceProps } from './redirect-to-personal-space-type';

import enhancer from './redirect-to-personal-space-enhancer';

const redirectToPersonalSpace: React.FC<RedirectToPersonalSpaceProps> = ({
    folder,
    basePath,
}: RedirectToPersonalSpaceProps) => {
    if (!folder || folder.type === FolderTypeValues.UNKNOWN) {
        return <React.Fragment />;
    }

    return <Redirect to={concatUrl([basePath, routes[folder.type].path])} />;
};

export const RedirectToPersonalSpace = enhancer(redirectToPersonalSpace);
